export default __webpack_public_path__ + "assets/images/32f7bbd77de6b9754338cdc83087fbee-mgm_thumbnail_default.png";